import React, { useCallback, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import Link from '@atlaskit/link';
import { ff } from '@atlassian/jira-feature-flagging';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useRouter } from '@atlassian/jira-router';
import { IMPORT_URL_SUFFIX, NEW_EXTERNAL_IMPORT_URL } from '../../constants';

type Props = {
	content: string | ReactNode;
};

export const SwitchBackToOldExperienceLink = ({ content }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ location }] = useRouter();

	const onClick = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'switchToOldExperienceLink',
			}),
		);
	}, [createAnalyticsEvent]);
	if (ff('x2c-jim-home-screen-replacement_eikwe')) {
		return (
			<Button
				appearance="link"
				spacing="none"
				target={location.pathname === NEW_EXTERNAL_IMPORT_URL ? '_self' : '_blank'}
				href={IMPORT_URL_SUFFIX}
				onClick={onClick}
				testId="project-create-importer-upload-flow.common.ui.old-experience-link.link"
			>
				{content}
			</Button>
		);
	}

	return (
		<Link
			href={IMPORT_URL_SUFFIX}
			testId="project-create-importer-upload-flow.common.ui.old-experience-link.link"
			onClick={onClick}
			target="_blank"
		>
			{content}
		</Link>
	);
};
